/**
 * Hareket kaydedildikten sonra çıkan dekont penceresi.
 *
 * Döviz işlemi İKİ bacak yazdığı için liste alır: her bacağın kendi dekontu var.
 */
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription,
} from '@/components/ui/dialog';
import { Receipt, Download } from 'lucide-react';
import { dekontuAc } from '@/lib/dekont';

export default function DekontDialog({ dekontlar, onClose }) {
  const [mesgul, setMesgul] = useState(null);
  const liste = dekontlar || [];

  const tikla = async (id, indir) => {
    setMesgul(`${id}-${indir ? 'i' : 'g'}`);
    await dekontuAc(id, indir);
    setMesgul(null);
  };

  return (
    <Dialog open={liste.length > 0} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="bg-[#faf7f2] border-[#d0c4b0] max-w-md">
        <DialogHeader>
          <DialogTitle className="text-[#1a1916] font-bold">Hareket kaydedildi</DialogTitle>
          <DialogDescription className="text-xs text-[#8a7e70]">
            Ödeme dekontunu görüntüleyip çıktı alabilirsiniz. Dekonta daha sonra hareket
            listelerindeki fiş simgesinden de ulaşabilirsiniz.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          {liste.map(d => (
            <div key={d.id} className="flex items-center gap-2 flex-wrap">
              {liste.length > 1 && (
                <span className="text-sm text-[#3F3E39] w-28 shrink-0">{d.etiket}</span>
              )}
              <Button variant="outline" className="border-[#d0c4b0]" disabled={mesgul === `${d.id}-g`}
                onClick={() => tikla(d.id, false)} data-testid={`dekont-goruntule-${d.id}`}>
                <Receipt size={15} className="mr-1.5" /> Dekont Görüntüle
              </Button>
              <Button variant="outline" className="border-[#d0c4b0]" disabled={mesgul === `${d.id}-i`}
                onClick={() => tikla(d.id, true)} data-testid={`dekont-indir-${d.id}`}>
                <Download size={15} className="mr-1.5" /> Dekont İndir
              </Button>
            </div>
          ))}
        </div>
        <DialogFooter>
          <Button onClick={onClose} className="bg-[#2e2d29] text-[#f5f0e8] hover:bg-[#1a1916]">Kapat</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
